'use client';

import type { FC } from 'react';
import { useEffect } from 'react';
import { BottomSheet, Switch } from '../ui';
import { useCaseBattlePrefsStore, type CaseBattlePrefs } from '../../stores/caseBattlePrefsStore';
import { useCaseBattleT } from './atoms';

export const useCaseBattlePrefs = () => {
  const store = useCaseBattlePrefsStore();
  useEffect(() => {
    store.hydrate();
  }, [store]);
  return store;
};

interface CaseBattleSettingsSheetProps {
  isOpen: boolean;
  onClose: () => void;
}

const PrefRow: FC<{ pref: keyof CaseBattlePrefs; title: string; hint: string }> = ({ pref, title, hint }) => {
  const prefs = useCaseBattlePrefs();
  return (
    <label className="flex min-h-16 w-full cursor-pointer items-center gap-3 rounded-2xl bg-white/[0.06] px-4 py-3">
      <span className="flex min-w-0 flex-1 flex-col leading-tight">
        <span className="truncate text-[16px] font-semibold text-label-primary">{title}</span>
        <span className="line-clamp-2 text-[13px] text-label-secondary">{hint}</span>
      </span>
      <Switch checked={prefs[pref]} onChange={(on) => prefs.setPref(pref, on)} />
    </label>
  );
};

export const CaseBattleSettingsSheet: FC<CaseBattleSettingsSheetProps> = ({ isOpen, onClose }) => {
  const { t } = useCaseBattleT();
  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('settingsTitle')} heightClass="h-auto max-h-[70vh]">
      <div className="flex flex-col gap-2 px-2 pb-4 pt-1">
        <PrefRow pref="affordableOnly" title={t('settingsAffordable')} hint={t('settingsAffordableHint')} />
        <PrefRow pref="hideRunning" title={t('settingsHideRunning')} hint={t('settingsHideRunningHint')} />
        <PrefRow pref="reactions" title={t('settingsReactions')} hint={t('settingsReactionsHint')} />
      </div>
    </BottomSheet>
  );
};
